import React from "react";
import { Button } from "react-bootstrap";

const StockTable = ({
  stockList,
  setSelectedProduct,
  setShowStockModal,
  setAdjustment,
  onShowHistory,
}) => {
  return (
    <div className="table-responsive">
      <table className="table table-hover table-vcenter table-sm">
        <thead>
          <tr>
            <th>No</th>
            <th>Product</th>
            <th>Category</th>
            <th>Stock</th>
            <th className="text-end">Actions</th>
          </tr>
        </thead>
        {stockList.length > 0 ? (
          <tbody>
            {stockList.map((data, index) => (
              <tr
                key={index}
                onClick={() => onShowHistory(data)}
                style={{ cursor: "pointer" }}
              >
                <td>{index + 1}</td>
                <td>{data.name}</td>
                <td>{data.category}</td>
                <td>{data.stock}</td>
                <td className="text-end">
                  <Button
                    variant="success"
                    size="sm"
                    className="me-2"
                    onClick={(e) => {
                      e.stopPropagation(); // 🔥 Mencegah trigger modal history saat klik button
                      setSelectedProduct(data);
                      setAdjustment(1);
                      setShowStockModal(true);
                    }}
                  >
                    + Add
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedProduct(data);
                      setAdjustment(-1);
                      setShowStockModal(true);
                    }}
                    disabled={data.stock <= 0}
                  >
                    - Reduce
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        ) : (
          <tbody>
            <tr>
              <td colSpan="5" className="text-center">
                No data available
              </td>
            </tr>
          </tbody>
        )}
      </table>
    </div>
  );
};

export default StockTable;
